var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentDropdown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1933 1.13536C10.3342 0.988664 10.5252 0.90625 10.7243 0.90625C10.9235 0.90625 11.1145 0.988664 11.2553 1.13536C11.3962 1.28206 11.4753 1.48102 11.4753 1.68849C11.4753 1.89595 11.3962 2.09491 11.2553 2.24161L6.53034 7.16244C6.38971 7.30875 6.19909 7.39092 6.00034 7.39092C5.80159 7.39092 5.61096 7.30875 5.47034 7.16244L0.745338 2.24161C0.604508 2.09491 0.525391 1.89595 0.525391 1.68849C0.525391 1.48102 0.604508 1.28206 0.745338 1.13536C0.886168 0.988664 1.07717 0.90625 1.27634 0.90625C1.4755 0.90625 1.66651 0.988664 1.80734 1.13536L6.00034 5.50307L10.1933 1.13536Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentDropdown);
export default __webpack_public_path__ + "static/media/paymentDropdown.551f0fdf46f01898aa5d7fad637c1519.svg";
export { ForwardRef as ReactComponent };